import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../services/hooks";
import { adminSelector } from "../../services/selectors/user.selectors";
import { isAuthSelector } from "../../services/selectors/auth.selectors";
import { peekPostAuthRedirect } from "../../utils/postLoginRedirect";

type Props = {
  children: JSX.Element;
};

const PublicOnlyRoute = ({ children }: Props) => {
  const admin = useAppSelector(adminSelector);
  const isAuth = useAppSelector(isAuthSelector);

  if (isAuth) {
    const pending = peekPostAuthRedirect();
    if (pending) {
      return <Navigate to={pending} replace />;
    }
    if (admin?.companyId) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default PublicOnlyRoute;
